module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-block"
  }, [_c('div', {
    staticClass: "info-block_field"
  }, [
    [_c('router-link', {
      staticClass: "action_link",
      attrs: {
        "to": ("/program/" + (_vm.programName.to.params.id))
      }
    }, [_c('div', {
      staticClass: "info-block_field__label"
    }, [_vm._v(_vm._s(_vm.programName.label + ' ' + _vm.programName.value))])])]
  ], 2), _vm._l((_vm.infoElements), function(elem, index) {
    return _c('div', {
      key: index,
      staticClass: "info-block_field"
    }, [(index < _vm.currentPreviewCount) ? [
      [_c('div', {
        staticClass: "info-block_field__label"
      }, [_vm._v(_vm._s(elem.label))]), _c('div', {
        staticClass: "info-block_field__value"
      }, [_vm._v(_vm._s(elem.value))])]
    ] : _vm._e()], 2)
  }), _c('div', {
    staticClass: "info-block_field"
  }, [_c('div', [(_vm.item.id && _vm.currentPreviewCount !== _vm.previewCount) ? [_c('a', {
    staticClass: "action_link",
    on: {
      "click": function($event) {
        return _vm.getDoc(_vm.item.id)
      }
    }
  }, [_vm._v("Документ об обучении")])] : _vm._e()], 2)]), _c('button', {
    staticClass: "action_link",
    on: {
      "click": _vm.expand
    }
  }, [_vm._v(_vm._s(this.previewCount === this.currentPreviewCount ? 'Подробнее' : 'Свернуть'))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-086a761a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/resultCourses/components/InfoBlock.vue
// module id = 0016ead740d43ea864ff
// module chunks = 23